/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Box from "@mui/material/Box";
import "./CSS/layout.css";
import { useParams } from "react-router-dom";
import apiService from "../../services/api-service";
import ComplexStatisticsCard from "../../examples/Cards/StatisticsCards/ComplexStatisticsCard";
import BasicLayoutLanding from "../../layouts/authentication/components/BasicLayoutLanding";
import AuthService from "services/auth-service";
import { AuthContext } from "context";
import { AuthContextSingleton } from "../../auth/authContext/authContext";

function AreaSelection() {
	const authContext = useContext(AuthContext);
	const [aree, setAree] = useState([]);
	const [areaSelect, setAreaSeledt] = useState(
		localStorage.getItem("areaSelected")
	);
	const [showSideBar, setShowSideBar] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		apiService
			.get("/user-area/", {}, {})
			.then((data) => setAree(data))
			.catch((error) => console.log(error));
	}, []);

	useEffect(() => {
		if (areaSelect) {
			setShowSideBar(true);
		} else {
			setShowSideBar(false);
		}
	}, [areaSelect]);

	function selectArea(area) {
		localStorage.setItem("areaSelected", area[0]);
		localStorage.setItem("areaName", area[1]);
		setShowSideBar(true);
		apiService
			.get("/user-area-auth/", `area=${area[0]}`, {})
			.then((data) => authContext.setAuth(data), navigate("/"))
			.catch((error) => console.log(error));
		apiService
			.get("/check-user-supplier/", null, {})
			.then((data) => {
				if (data?.supplier) {
					localStorage.setItem("supplier", data?.supplier);
				}
			})
			.catch((error) => console.log(error));
	}

	return (
		<BasicLayoutLanding>
			<Box className="container">
				{aree.map((area) => {
					return (
						<MDBox width="100%" onClick={() => selectArea(area)}>
							<ComplexStatisticsCard
								color="dark"
								icon="home"
								title="Cantiere"
								count={area[1]}
							/>
						</MDBox>
					);
				})}
			</Box>
		</BasicLayoutLanding>
	);
}

export default AreaSelection;
